import React, {useCallback} from 'react';
import PropTypes from "prop-types";
import {OutlineErrorIcon} from "presentation/common/components/style-guide/icons";
import {Button} from "presentation/common/components";
import styles from './ConfirmMessage.module.scss';
import clsx from "clsx";
import {emptyFn} from "presentation/common/helpers/utils";

export const ConfirmMessageContent = (props) => {
  const {message, title, Icon = OutlineErrorIcon, onClose, onConfirm, onCancel} = props;

  const closeFn = useCallback(
    () => {
      onCancel && onCancel();
      onClose && onClose();
    },
    [onCancel, onClose]);

  return (
    <div className={styles.container}>
      <div className="text-center mb-0 lg:mb-3"><Icon stroke="#FFB350"/></div>
      <div className="pb-2 lg:pb-0">
        <h3 className={clsx("text-lg text-center lg:pt-1 pb-1", styles.title)}>{title}</h3>
        <p className={clsx("text-center pb-8", styles.message)}>{message}</p>
      </div>

      <div className="text-center">
        <Button label="Cancelar" onClick={closeFn} theme='outline' className="mr-6"/>
        <Button label="Aceptar" onClick={onConfirm}/>
      </div>
    </div>
  );
};

ConfirmMessageContent.defaultProps = {
  title: '¿Está seguro que desea continuar?',
  message: 'Los datos ingresados en la solicitud se perderán.',
  onClose: emptyFn,
  onConfirm: emptyFn
};

ConfirmMessageContent.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};

export default React.memo(ConfirmMessageContent);
